import { useQuery } from '@tanstack/react-query';

import { fetchCollectionReport } from '../reports/reports.api';
import { fetchDashboardSummary } from './dashboard.api';

export const useDashboardSummary = () => useQuery({
  queryKey: ['dashboard', 'summary'],
  queryFn: fetchDashboardSummary,
  staleTime: 30_000,
  refetchInterval: 60_000,
});

export const useDashboardCollections = (fromDate: string, toDate: string) => useQuery({
  queryKey: ['dashboard', 'collections', fromDate, toDate],
  queryFn: () => fetchCollectionReport({ fromDate, toDate }),
  staleTime: 30_000,
  refetchInterval: 60_000,
});
